import downloadData from "./downloadData";

const downloadDataService = [{
    matcher: 'cropCertificationDataDownload',
    reply: config => {
        return [200, downloadData];
    }
}]

export default downloadDataService